import { render, staticRenderFns } from "./AdvancedMarkdown.vue?vue&type=template&id=2428d929&scoped=true&"
import script from "./AdvancedMarkdown.vue?vue&type=script&lang=js&"
export * from "./AdvancedMarkdown.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedMarkdown.vue?vue&type=style&index=0&id=2428d929&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2428d929",
  null
  
)

export default component.exports